/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FrameHeader from "./components/FrameHeader.vue";
import FrameFooter from "./components/FrameFooter.vue";
import FrameSideLeft from "./components/FrameSideLeft.vue";
import FrameSideRight from "./components/FrameSideRight.vue";
import FrameContent from "./components/FrameContent.vue";

import ModalsIndex from "./components/modals/ModalsIndex.vue";

import appConfig from "./api/appConfig";


const timer = self => {
  return setTimeout(() => {
    self.vars.idleTimer = null;
    console.log("Time up, reset store");
    self.$store.dispatch("reset");
    self.$store.dispatch("startIdling");
    self.updateFromCache();
  }, appConfig.idleTimerLength);
};

const __vue_script__ = {
  components: {
    FrameHeader,
    FrameFooter,
    FrameSideLeft,
    FrameSideRight,
    FrameContent,
    ModalsIndex,
  },
  created() {
    // these vars are not in the data() because, they are not reactive
    this.vars = {
      idleTimer: null,
    };
  },
  mounted() {
    this.$store.dispatch("dataPollStart");
  },
  destroyed() {
    this.$store.dispatch("dataPollEnd");
  },
  methods: {
    manageIdleTimer: function() {
      if (this.vars.idleTimer) {
        // reset timer
        clearTimeout(this.vars.idleTimer);
        this.vars.idleTimer = timer(this);
      } else {
        // start timer
        this.vars.idleTimer = timer(this);
        this.$store.dispatch("endIdling");
      }
    },
    updateFromCache: function() {
      this.$store.dispatch("getCachedData");
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrap",
      attrs: { id: "app" },
      on: { click: _vm.manageIdleTimer },
    },
    [
      _c("ModalsIndex"),
      _vm._v(" "),
      _c("FrameHeader"),
      _vm._v(" "),
      _c("FrameSideLeft"),
      _vm._v(" "),
      _c("FrameContent"),
      _vm._v(" "),
      _c("FrameSideRight"),
      _vm._v(" "),
      _c("FrameFooter"),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/App.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__